<template>
  <ui-modal @hidden="cancel">
    <div class="header">{{ $t("header") }}</div>
    <div class="content">
      <p :class="$style.date">{{ noticeTime }}</p>
      <div class="body" v-html="$t('body', { closingTime })"></div>
    </div>
    <div class="actions">
      <button class="ui ok button">
        {{ $t("buttons.close") | cap }}
      </button>
    </div>
  </ui-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import UiModal from '@/components/UiModal.vue'

export default {
  components: {
    UiModal
  },
  methods: {
    cancel () {
      this.$emit('cancel')
    }
  },
  computed: {
    ...mapGetters({
      closingTime: 'closingTimeLocale',
      noticeTime: 'noticeTimeLocale'
    })
  },
  i18n: {
    messages: {
      ko: {
        header: '서비스 종료 안내',
        body: `
          <p>안녕하세요, 리드그라피입니다.</p>
          <p>서비스 운영에 어려움으로 인하여 리드그라피가 서울 시간 기준 {closingTime}부로 서비스가 종료될 예정입니다. 메모 데이터를 보유하고 계신 분들은 종료되기 전 <a href="https://readgraphyapp.com">리드그라피 웹사이트</a>에 접속하셔서 내보내기 및 이미지 다운로드로 데이터를 백업해주시기 바랍니다.</p>
          <p>서비스를 게시한 2017년부터 리드그라피에 관심 가지고 이용해주신 모든 분들께 감사의 말씀드립니다.</p>
          <p>감사합니다.</p>
        `
      },
      en: {
        header: 'End of Service Notice',
        body: `
          <p>Dear Readgraphy User,</p>
          <p>Due to difficulties in service operation, Readgraphy is scheduled to end its service at {closingTime} Seoul time. If you have memo data, please access <a href="https://readgraphyapp.com">Readgraphy website</a> before closing and back up your data by exporting memo data and downloading images.</p>
          <p>I would like to thank everyone who has been interested in and used Readgraphy since 2017, when the service was published.</p>
          <p>Sincerely,</p>
        `
      }
    }
  }
}
</script>

<style module>
.date {
  font-weight: 400;
  font-size: 12px;
  text-align: right;
  margin-bottom: 5px;
}
</style>
